import { apiDataManagerBaseURL } from '../../authentication/Global';
import { authenticationCentral } from '../../authentication/Authentication';
import { API, HTTPMethod, ContentType } from '../APICentral';

const lanesApiRoutes = {
    list: apiDataManagerBaseURL + "lanes/",
    create: apiDataManagerBaseURL + "lanes/",
    update: apiDataManagerBaseURL + "lanes/",
    delete: apiDataManagerBaseURL + "lanes/",
};

export class LaneAPI {
    constructor() {
        this.baseUrl = new URL("lanes/", apiDataManagerBaseURL);
    }

    static list(type, laneType, countyEdition) {
        const listUrl = `${lanesApiRoutes.list}${type}/${laneType}/${countyEdition}`;

        return API.authenticatedRequest({
            url: listUrl,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }
    
    static create(type, laneType, countyEdition, lane) {
        const createUrl = `${lanesApiRoutes.create}${type}/${laneType}/${countyEdition}`

        return API.authenticatedRequest({
            url: createUrl,
            method: HTTPMethod.POST,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(lane)
        });
    }

    static update(type, laneType, countyEdition, id, lane) {
        const updateUrl = `${lanesApiRoutes.update}${type}/${laneType}/${countyEdition}/${id}`

        return API.authenticatedRequest({
            url: updateUrl,
            method: HTTPMethod.PUT,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(lane)
        });
    }

    static delete(type, laneType, countyEdition, id) {
        const deleteUrl = `${lanesApiRoutes.delete}${type}/${laneType}/${countyEdition}/${id}`

        return API.authenticatedRequest({
            url: deleteUrl,
            method: HTTPMethod.DELETE,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

}



// WEBPACK FOOTER //
// ./src/api/datamanager/LaneAPI.js